
import { mapState, mapActions } from 'vuex'
import XHeader from 'vux/src/components/x-header/index.vue'
import Panel from 'vux/src/components/panel/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'

import meiqia from '../../utils/meiqia'
import videoPlay from '../../utils/video-play.js'

export default {
name: 'CustomArticle',
components: {
XHeader,
Panel,
Previewer,
XImg,
},
data() {
return {
imgList: [],
}
},
computed: {
...mapState({
article: ({ raiders }) => raiders.raiders,
}),
title() {
if (this.$route.name === 'match-raiders') {
return '观赛攻略'
} else if (this.$route.name === 'refer-route') {
return '参考线路'
} else if (this.$route.name === 'show-article') {
return this.article.category.name
}
return '出游攻略'
},
mainImage() {
const { img } = this.$route.params
if (img) {
return `https:${img}`
}
return '//qncommon.saiday.com/yoyo/common/share_icon.png'
},
},
methods: {
...mapActions(['fetchRaiders']),
generateImgList() {
const images = document.querySelectorAll('.custom-article-wrapper img')
return Array.from(images).map(img => ({
src: img.src,
w: img.getAttribute('data-width') || 600,
h: img.getAttribute('data-height') || 400,
}))
},
popUpImg(event) {
if (event.target.tagName === 'IMG') {
const idx = this.imgList.map(im => im.src).indexOf(event.target.src)
this.$refs.previewer.show(idx !== -1 ? idx : 0)
}
},
initialWeixinShare(para) {
const { wx } = window
if (wx) {
wx.ready(() => {
const shareInfo = {
title: para.title,
desc: para.category && para.category.name,
link: window.location.href,

imgUrl: this.mainImage,
}

wx.onMenuShareAppMessage(shareInfo)
wx.onMenuShareTimeline(shareInfo)
})
}
},
},
created() {
meiqia.init(this.$route.name)
const to = this.$route
this.fetchRaiders(to.params.articleId).then(() => {
this.imgList = this.generateImgList()
this.article.videos.forEach((video) => {
const cover = video.cover ? video.cover.url : ''
videoPlay(video.id, video.url, cover)
})
})
this.$http.post(`/api/simpleArticle/${to.params.articleId}`).then(res => res.json())
.then((data) => {
this.initialWeixinShare(data)
})
.catch((err) => {
self.showToast({
content: err.body.resultInfo,
})
})
},
}



// WEBPACK FOOTER //
// ./client/components/Custom/CustomArticle.vue